import {
    IonButton,
    IonButtons,
    IonCard,
    IonContent,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonSpinner,
    IonText,
    IonTitle,
    IonToolbar,
} from "@ionic/react";
import { trashOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";

import { setDeselectAllLocations, setDeselectLocation } from "../../../store/formsubmitted";
import { selectFilterLocationSelected } from "../../../store/formsubmitted/selectors/selectFilterLocationSelected";
import { RootState } from "../../../store/rootReducer";
import { ConfirmButton } from "./ConfirmButton";
import { LocationSelectedSearchBar } from "./LocationSelectedSearchBar";

export const LocationSelected = () => {
    const dispatch = useDispatch();
    const selectedLocations = useSelector((state: RootState) => state.formSubmittedSlice.selectedLocations);
    const filterSelectedLocations = useSelector(selectFilterLocationSelected);
    const findAssignedLocationsStatus = useSelector((state: RootState) => state.formSubmittedSlice.findAssignedLocationsStatus)
 
    return (
        <IonCard style={{ height: "75vh" }} class="ion-no-margin">
            <IonToolbar color="primary">
                <IonTitle size="small" style={{ fontWeight: 500 }}>
                    Seleccionados ({selectedLocations.length})
                </IonTitle>
                <IonButtons slot="end">
                    {!!selectedLocations.length && (
                        <IonButton
                            fill="solid"
                            color="danger"
                            onClick={() => {
                                dispatch(setDeselectAllLocations());
                            }}
                            size="small"
                        >
                            <small>Quitar todos</small>
                            <IonIcon icon={trashOutline} slot="end" />
                        </IonButton>
                    )}
                    <ConfirmButton />
                </IonButtons>
            </IonToolbar>
            <LocationSelectedSearchBar />
            <IonContent style={{ overlay: "scroll", height: "60vh" }}>
                <IonList>
                    {findAssignedLocationsStatus === "succeeded" && filterSelectedLocations.map((item) => (
                        <IonItem key={item.id}>
                            <IonLabel>
                                <h2 style={{ fontWeight: 700 }}>
                                    <IonText color="primary">{item.name}</IonText>
                                </h2>
                                <h4>
                                    <IonText color="medium" style={{ fontWeight: 500 }}>
                                        {item?.code}
                                    </IonText>
                                </h4>
                            </IonLabel>
                            <IonButton
                                fill="clear"
                                onClick={() => {
                                    dispatch(setDeselectLocation(item));
                                }}
                                size="large"
                            >
                                <IonIcon icon={trashOutline} />
                            </IonButton>
                        </IonItem>
                    ))}
                    {findAssignedLocationsStatus === "pending" && (
                        <p className="ion-text-center">
                            <IonSpinner />
                        </p>
                    )}
                </IonList>
            </IonContent>
        </IonCard>
    );
};
